export const aciSub = {
    iconName: 'sub',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 25' },
        path: [
            {
                attr: {
                    d: 'M7.5 12.605h9',
                    stroke: 'currentColor',
                    'stroke-width': '1.5',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    'clip-rule': 'evenodd',
                    d: 'M12 23.855c6.213 0 11.25-5.036 11.25-11.25 0-6.213-5.037-11.25-11.25-11.25S.75 6.392.75 12.605c0 6.214 5.037 11.25 11.25 11.25z',
                    stroke: 'currentColor',
                    'stroke-width': '1.5',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
